module.exports = __webpack_public_path__ + "assets/img/20211026.f465c7d2.png";